{
	"backLinkTitle": "Torna a Gestisci dichiarazioni",
	"invoicedQuantity": "Quantità fatturata",
	"remainingForDeclarationCreation": "Rimanente per la creazione della dichiarazione",
	"nonTransferableAmount": "Importo non allocabile",
	"btnCreateDeclaration": "+ Crea dichiarazione",
	"errorMessage": "Impossibile caricare i dettagli del materiale"
}
